import {
  Component,
  useContext,
} from 'solid-js';
import { AuthContext, Button } from '../../components';

export const RouteAdmin: Component = () => {
  const { api } = useContext(AuthContext)!;

return <>
    <div class="buttons">
      <Button onClick={async () => {
        await api.postAdminMaintenanceOptimizeContentImages();
      }}>Optimize images</Button>
    </div>
    <div class="footer">
    </div>
  </>;
};
